import type {
  ApiBulkSession,
  GenericHttpResult,
  ApiMemberCommitResponse,
} from '@agunity/api-v4';

import { apiService } from '../../api/apiService';

export const getBulkUploadRequests = () => {
  return async (): Promise<GenericHttpResult<ApiBulkSession[]>> => {
    const response = await apiService.memberV10UploadsListList();
    return response;
  };
};

export const getBulkUploadRequestDetails = (key: string) => {
  return async (): Promise<GenericHttpResult<ApiBulkSession>> => {
    const response = await apiService.memberV10UploadsDetail(key);
    return response;
  };
};

export const postBulkUploadRequestCommit = (key: string) => {
  return async (): Promise<GenericHttpResult<ApiMemberCommitResponse>> => {
    const response = await apiService.memberBulkV10CommitCreate(key);
    return response;
  };
};
